import { Box, Switch, Typography } from "@mui/material";
import { useState } from "react";
import TableComponent from "../../shared/Dashboard/TableComponent";
import { useAtom } from "jotai";
import dashboardAtoms from "../../atoms/Dashboard/DashboardAtom";
import { columns as initialColumns } from '../../shared/Dashboard/constant';
import { useParams } from "react-router-dom";
import { getCurrentTerms } from "../../shared/projectTypeUtils";

const DashboardBomTable = (props) => {
    const { id } = useParams()
    const { selectPart, checked, setChecked, isSvg, selectedRow } = props;
    const [view, setView] = useState(false);
    const [openSelectedTrackersModal, setOpenSelectedTrackersModal] = useState(false)
    const [data] = useAtom(dashboardAtoms);
    const blockName = data?.blocks?.find((item) => item?.id === parseInt(id))?.name;
    const pierKeys = data?.bulkAllData?.piers ? Object.keys(data.bulkAllData.piers) : [];
    const isFullSelection = isSvg && (pierKeys.length === selectPart?.length || selectPart?.length === 0);
    const TERMS = getCurrentTerms()
    const { bomList = [] } = data;

    const BomTitle = isSvg
        ? isFullSelection
            ? `BOM Status for ${blockName}`
            : TERMS.BOM_FOR_SELECTED
        : selectPart.length === 0 ? "BOM Status for Project" : "BOM Status for Selected Blocks";

    const PopUpBomTitle = isSvg
        ? isFullSelection
            ? `${blockName} - Bill of Materials`
            : `${blockName} - Selected ${TERMS.TRACKERS_LABEL} - Bill of Materials`
        : selectPart.length === 0 ? "Bill of Materials - Project" : "Bill of Materials - Selected Blocks";

    return (
        <Box>
            <Box display="flex" gap={2} alignItems="center" justifyContent={"space-between"} sx={{ cursor: "pointer" }}>
                <Typography
                    color={isSvg && !selectPart?.length ? "gray" : "#3b84f6"}
                    ml={4}
                    variant="span"
                    onClick={() => {
                        if (!(isSvg && !selectPart?.length)) {
                            setView(true);
                        }
                    }}
                    fontSize={16}
                    fontWeight={600}
                    gutterBottom
                    sx={{
                        cursor: isSvg && !selectPart?.length ? "not-allowed" : "pointer"
                    }}
                >
                    {BomTitle}
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Switch
                        checked={checked !== undefined ? checked : false}
                        onChange={(e) => setChecked(e.target.checked)}
                        disabled={!id}
                    />
                    <Typography fontSize={16}>
                        Mark Progress
                    </Typography>
                </Box>

            </Box>
            {view && (
                <TableComponent
                    data={bomList}
                    open={view}
                    setIsOpen={setView}
                    initialColumns={initialColumns}
                    selectPart={selectPart}
                    isSvg={isSvg}
                    title={PopUpBomTitle}
                    selectedRow={selectedRow}
                    trackerList={data?.trackerList}
                    openSelectedTrackersModal={openSelectedTrackersModal}
                    setOpenSelectedTrackersModal={setOpenSelectedTrackersModal}
                    showViewSelectedButton={isSvg && !isFullSelection}
                />
            )}
        </Box>
    )
}

export default DashboardBomTable;
